/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventRemoteType,
    EventRemoteTypeFromJSON,
    EventRemoteTypeFromJSONTyped,
    EventRemoteTypeToJSON,
    EventType,
    EventTypeFromJSON,
    EventTypeFromJSONTyped,
    EventTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface VehicleEventInfo
 */
export interface VehicleEventInfo {
    /**
     * 
     * @type {string}
     * @memberof VehicleEventInfo
     */
    vin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEventInfo
     */
    regNr?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleEventInfo
     */
    eventDate?: Date;
    /**
     * 
     * @type {EventType}
     * @memberof VehicleEventInfo
     */
    eventType?: EventType;
    /**
     * 
     * @type {Date}
     * @memberof VehicleEventInfo
     */
    seenDate?: Date;
    /**
     * 
     * @type {EventRemoteType}
     * @memberof VehicleEventInfo
     */
    remoteType?: EventRemoteType;
    /**
     * 
     * @type {string}
     * @memberof VehicleEventInfo
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEventInfo
     */
    info?: string | null;
}

export function VehicleEventInfoFromJSON(json: any): VehicleEventInfo {
    return VehicleEventInfoFromJSONTyped(json, false);
}

export function VehicleEventInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleEventInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
        'regNr': !exists(json, 'regNr') ? undefined : json['regNr'],
        'eventDate': !exists(json, 'eventDate') ? undefined : (new Date(json['eventDate'])),
        'eventType': !exists(json, 'eventType') ? undefined : EventTypeFromJSON(json['eventType']),
        'seenDate': !exists(json, 'seenDate') ? undefined : (new Date(json['seenDate'])),
        'remoteType': !exists(json, 'remoteType') ? undefined : EventRemoteTypeFromJSON(json['remoteType']),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'info': !exists(json, 'info') ? undefined : json['info'],
    };
}

export function VehicleEventInfoToJSON(value?: VehicleEventInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vin': value.vin,
        'regNr': value.regNr,
        'eventDate': value.eventDate === undefined ? undefined : (value.eventDate.toISOString()),
        'eventType': EventTypeToJSON(value.eventType),
        'seenDate': value.seenDate === undefined ? undefined : (value.seenDate.toISOString()),
        'remoteType': EventRemoteTypeToJSON(value.remoteType),
        'country': value.country,
        'info': value.info,
    };
}


